// extracted by mini-css-extract-plugin
module.exports = {"typeBadge":"_collectionIcon-styles-module--typeBadge--2PiPJ","css":"_collectionIcon-styles-module--css--u4EdO"};